import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ProductAgreementDTO } from '@iota/iota-management-portal-v4-client';
import { ModalService } from '@iota/iota-ui-components';
import { deepCopy } from '../../constants-and-enums/default-objects';
import { ConfirmationDialogData, DialogConfirmationComponent } from '../../dialogs/dialog-confirmation/dialog-confirmation.component';

@Component({
    standalone: false,
    selector: 'app-product-agreement',
    templateUrl: './product-agreement.component.html',
    styleUrls: ['./product-agreement.component.scss']
})
export class ProductAgreementComponent implements OnInit {
    editMode = false;
    @Input() agreement: ProductAgreementDTO;

    @Output() delete: EventEmitter<ProductAgreementDTO> = new EventEmitter();
    @Output() save: EventEmitter<ProductAgreementDTO> = new EventEmitter();
    @Output() cancelEdit: EventEmitter<string> = new EventEmitter();

    form = new UntypedFormGroup({
        name: new UntypedFormControl(null, [Validators.required]),
        comment: new UntypedFormControl(null, [Validators.required]),
        versionFrom: new UntypedFormControl(null, Validators.required),
        versionTo: new UntypedFormControl()
    });

    resetVersionTo(): void {
        this.form.controls.versionTo.reset();
    }

    edit(): void {
        this.form.enable();
        this.editMode = true;
    }

    constructor(private dialog: ModalService) {}

    resetValues() {
        const { name, comment, versionFrom, versionTo } = this.agreement;
        this.form.patchValue({
            name,
            comment,
            versionFrom,
            versionTo
        });
        this.form.disable();
        this.editMode = false;
    }

    ngOnInit(): void {
        this.resetValues();
    }

    deleteAgreement() {
        const dialogData: ConfirmationDialogData = {
            title: $localize`Delete agreement`,
            text: $localize`Are you sure you want to delete the agreement?`,
            cancelButtonStyle: 'primary',
            confirmButtonStyle: 'error'
        };

        const dialogRef = this.dialog.open(DialogConfirmationComponent, {
            data: dialogData
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.delete.emit(this.agreement);
                this.editMode = false;
            }
        });
    }

    saveAgreement(): void {
        const { name, comment, versionFrom, versionTo } = this.form.getRawValue();

        const updatedAgreement = deepCopy(this.agreement);
        updatedAgreement.name = name;
        updatedAgreement.comment = comment;
        updatedAgreement.versionFrom = versionFrom;
        updatedAgreement.versionTo = versionTo ?? null;
        this.save.emit(updatedAgreement);
        this.editMode = false;
    }
}
